import type { SelectOption } from '@polyseme/design-system';

export const FONT_FAMILIES = ['inter', 'oswald', 'prata', 'unbounded'] as const;

export type FontFamily = (typeof FONT_FAMILIES)[number];

export const FONT_FAMILY_MAP: Record<FontFamily, string> = {
  inter: 'var(--font-inter)',
  prata: 'var(--font-prata)',
  oswald: 'var(--font-oswald)',
  unbounded: 'var(--font-unbounded)',
};

export const FONT_OPTIONS: SelectOption[] = [
  { label: 'Inter', value: 'inter' },
  { label: 'Prata', value: 'prata' },
  { label: 'Oswald', value: 'oswald' },
  { label: 'Unbounded', value: 'unbounded' },
];
